// @flow

import React                from 'react';
import { Route, Redirect }  from 'react-router-dom';
import { connect }          from 'react-redux';

const ProtectedRoute = ({ isAuthenticated, wholeState, component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => (
        isAuthenticated ? ( <Component {...props} /> ) : ( <Redirect to={{ pathname: '/session/login', state: { from: props.location } }} />
      )
    )}/>
  )
}

const mapStateToProps = (state) => {
  return { isAuthenticated: state.user.id }
}

export default connect(mapStateToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/components/common/protectedRoute/protectedRoute.js